<div class="content">
    <svg-icon [fontSize]="'110px'" key="alert"></svg-icon>
    <div class="error-title">{{errorTitle}}</div>
</div>
